import { Button, Container, Grid, Stack } from "@mui/material";
import TSStudio from "../../assets/images/TSStudio.png";
import { useDialogContext } from "../../contexts";

export const TSStudioPage = () => {

    const openDialog = useDialogContext();

    const handleOnClick = () => {
        openDialog({
            title: "Iscrizione avvenuta con successo",
            content: "A breve verrai ricontattato"
        });
    }

    return (
        <Container maxWidth="md" sx={{ height: 'calc(100vh - 100px)' }} >
            <Grid spacing={2} container>
                <Grid sm={12} sx={{ display: 'flex', flexDirection: 'column', overflow: 'auto', alignItems: 'center' }} item>
                    <img src={TSStudio} alt="TS Studio" width="50%" />
                </Grid>
                <Grid sm={12} item>
                    <Stack direction="row" justifyContent="center" alignItems="center" gap={2}>
                        <Button color="primary" variant="contained" onClick={handleOnClick}>
                            Iscriviti al webinar
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </Container>
    );
};
